import { ChecklistMetricStatus } from '../../handoff-checklist-v2/handoff-checklist-v2.types';
import { WieMetricDefinition } from '../wie-metrics.types';
import { Feature } from '@weave/schema-gen-ts/dist/shared/feature/location_feature.pb';
import { CustomizationFlagStatesV2 } from 'models/location-feature.model';

export const wieFlagsMetric: WieMetricDefinition = {
  id: 'wie_flags',
  name: 'WIE Flags',
  isRequired: true,
  criteria: [
    {
      description: 'Enable Enhanced Insurance Verification customization flag.',
      evaluate: async (ctx) => {
        const feature = ctx.customizationFeatures.find(
          (f) => f.featureEnum === Feature.ENHANCED_INSURANCE_VERIFICATION
        );
        const isActive = feature?.state === CustomizationFlagStatesV2.ACTIVE;

        if (!isActive) {
          return {
            status: ChecklistMetricStatus.BLOCKED,
            message:
              'Enable the "Enhanced Insurance Verification" customization flag in WAM settings.',
          };
        }
        return { status: ChecklistMetricStatus.PASSED };
      },
    },
  ],
};
